import React from 'react';

import { WorkspacesType } from 'Dashboard/components/Onboarding/OnboardingWizard/types';
import CharmaLogo from 'Shared/components/Logos/CharmaLogo';
import Avatar from 'Shared/components/Avatar/Avatar';
import { sanitizeFullName } from 'Shared/helpers';
import { AvatarType } from 'Shared/constants/types';
import WpIcon from 'Wpds/components/icon/WpIcon';
import { WpButton } from 'Wpds/components/button';
import { defaultSidebarItems } from './constants';
import './FakeSideNavigation.scss';

type Props = {
  workspaces: WorkspacesType;
  currentUser: {
    fullName: string;
    avatar: AvatarType;
  };
};

function FakeSideNavigation({ workspaces, currentUser }: Props) {
  const currentUserAvatar = currentUser.avatar;
  const formatedWorkspaces = [
    {
      uuid: 'private-workspace',
      avatar: currentUserAvatar,
      displayName: 'You (Private)',
    },
    ...workspaces.map(({ uuid, avatar, fullName }) => ({
      uuid,
      avatar,
      displayName: sanitizeFullName(fullName),
    })),
  ];

  return (
    <>
      <div className="fake-side-navigation wp-sidebar pt-4 px-2 pb-5 d-none d-md-block">
        <CharmaLogo width="160" />
        <ul className="navbar-nav sidebar-nav my-4 w-100">
          {defaultSidebarItems.map(({ label, icon }) => (
            <li key={label} className="nav-item">
              <a href="#" className="nav-link d-flex align-items-center">
                <span className="mr-4">
                  <WpIcon name={icon} size="lg" />
                </span>
                <div className="d-inline">{label}</div>
              </a>
            </li>
          ))}
        </ul>
        <div className="mt-3 w-100">
          <div className="team-group-template py-1">
            <div className="team-group-template-title d-flex px-2 justify-content-between align-items-center text-muted text-uppercase">
              <span>1:1 Workspaces</span>
              <WpIcon name="plus-square" />
            </div>

            <div className="navbar-nav sidebar-nav my-3 w-100">
              {formatedWorkspaces.map(({ displayName, avatar, uuid }, index) => (
                <a
                  key={uuid}
                  href="#"
                  className={`nav-link d-flex align-items-center my-1 ${index === 1 ? 'active' : ''}`}
                >
                  <div className="team-group-item-avatars d-flex align-items-center mr-2">
                    <Avatar avatar={avatar} height={28} />
                  </div>
                  <div className="team-item-name">{displayName}</div>
                </a>
              ))}
            </div>

            <WpButton variant="secondary" block>
              <WpIcon name="plus-circle" />
              Add 1:1 Workspace
            </WpButton>
          </div>
        </div>
        <div className="d-flex align-items-center cursor-pointer fake-side-navigation-user-settings border-top border-bottom py-1">
          <Avatar avatar={currentUserAvatar} height={28} classNames="mr-2" />
          Profile
          <span className="ml-auto">
            <WpIcon name="chevron-down" />
          </span>
        </div>
      </div>
      <div className="mobile-top-navigation d-flex d-md-none align-items-center justify-content-center mt-2">
        <CharmaLogo width="140" />
      </div>
    </>
  );
}

export default FakeSideNavigation;
